import type { Product } from '@bucketplace/common';
import { type QueryFunctionContext, skipToken } from '@tanstack/react-query';
import type { KyHeadersInit } from 'ky/distribution/types/options';
import { z } from 'zod';
import { getStoreItemsInputSchema } from '../get-store-items/get-store-items';

const storeItemFilterTypeSchema = z.enum(['BRAND', 'CATEGORY']);

const storeItemFilterSchema = z.object({
  type: storeItemFilterTypeSchema,
  ids: z.array(z.string()),
});

export const storeItemFilterChipSchema = storeItemFilterSchema.extend({
  name: z.string(),
});

export const getBestRankingStoreItemsInputSchema = getStoreItemsInputSchema
  .omit({ ids: true })
  .extend({
    limit: z.number().int().positive().optional(),
    type: storeItemFilterTypeSchema,
    filter: storeItemFilterSchema.nullish(),
  });

export const getBestRankingStoreItemsResponseSchema = z.object({
  chips: z.array(storeItemFilterChipSchema),
  items: z.array(z.custom<Product>()),
});

export type GetBestRankingStoreItemsInput = z.infer<
  typeof getBestRankingStoreItemsInputSchema
>;
export type GetBestRankingStoreItemsResponse = z.infer<
  typeof getBestRankingStoreItemsResponseSchema
>;
export type GetBestRankingStoreItemsApi = (params: {
  input: GetBestRankingStoreItemsInput;
  headers?: KyHeadersInit;
  signal?: AbortSignal;
}) => Promise<GetBestRankingStoreItemsResponse>;

export const createGetBestRankingStoreItemsQueryOptions = ({
  api,
  input,
  skip,
}: {
  api: GetBestRankingStoreItemsApi;
  input: GetBestRankingStoreItemsInput;
  skip?: boolean;
}) => {
  return {
    queryKey: ['getBestRankingStoreItems', input],
    queryFn: skip
      ? skipToken
      : ({ signal }: QueryFunctionContext) => api({ input, signal }),
  } as const;
};
